export default "__VITE_ASSET__234bbfab__"